import { makeStyles, css } from '@conexasaude/hero'

const loadingStyle = makeStyles({
  loading({ colors }) {
    return css`
      animation: is-rotating 1s infinite;
      border: 10px solid ${colors.neutral[100]};
      border-radius: 50%;
      border-top-color: ${colors.primary[500]};
      height: 100px;
      width: 100px;
      @keyframes is-rotating {
        to {
          transform: rotate(1turn);
        }
    `
  },
  auxiliaryText() {
    return css`
      display: block;
      margin-top: 15px;
    `
  },
  loadingContainer() {
    return css`
      height: 200px;
    `
  },
})

export default loadingStyle
